// extracted by mini-css-extract-plugin
module.exports = {"container":"e_SB","label":"e_TB","image":"e_UB","name":"e_VB","description":"e_WB","descriptionCollapsed":"e_XB","bottomLine":"e_YB","socialIcon":"e_ZB"};